import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";

import Login from "./Login"

import cookies from "./cookies"
import { Provider } from 'react-redux'
import store from './Redux';

import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';

import { ToastContainer } from 'react-toastify';

import * as Sentry from '@sentry/browser';
Sentry.init({
    dsn: "https://98d7d4e074d64cb69600b5baf94382e4@sentry.io/1399751"
});

class Logout extends React.Component {
    render() {
        cookies.remove("auth")
        return <Redirect to={"/"} />
    }
}

ReactDOM.render(
    <MuiPickersUtilsProvider utils={MomentUtils}>
        <Provider store={store}>
            <Router>
                <div>
                    <ToastContainer
                        position="top-right"
                        autoClose={1500}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnVisibilityChange
                        draggable
                        pauseOnHover
                    />
                    <App />
                    <Route exact path="/login" component={Login} />
                    <Route exact path="/logout" component={Logout} />
                </div>
            </Router>
        </Provider>
    </MuiPickersUtilsProvider>
, document.getElementById('root'));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js